import { DataUserMPFormType } from 'entities/users/types';

export const useCreateUsersDefaultValues = (): DataUserMPFormType => ({
  phone: '',
  first_name: '',
  last_name: '',
  middle_name: '',
  city_id: undefined,
  country_id: undefined,
  iin: null,
  source_id: undefined,
  role: undefined,
  selectedCountryCode: '',
  document_number: '',
  personal_number: '',
  issued_at: '',
  expiration_at: '',
});
